import PropTypes from 'prop-types';
import React from 'react';

const Stepper = ({ currentStep, isLocked, onNavigate }) => {
  const steps = [
    { label: 'Step 1: Select Stores', value: 1 },
    { label: 'Step 2: Configure and Submit', value: 2 },
  ];

  const handleClick = (step) => {
    if (isLocked || step === currentStep) return;
    onNavigate(step);
  };

  return (
    <nav aria-label="Bulk update steps" className="o2o-bulk-stepper">
      {steps.map((step, idx) => {
        const isActive = step.value === currentStep;
        const isCompleted = step.value < currentStep;
        const isDisabled = isLocked || (step.value > currentStep && !isCompleted);
        const className = `o2o-bulk-stepper-item${isActive ? ' is-active' : ''}${isCompleted ? ' is-completed' : ''}${isDisabled ? ' is-disabled' : ''}`;
        return (
          <React.Fragment key={step.value}>
            <button
              aria-current={isActive ? 'step' : undefined}
              className={className}
              disabled={isDisabled}
              type="button"
              onClick={() => handleClick(step.value)}
            >
              {step.label}
            </button>
            {idx < steps.length - 1 && <span aria-hidden="true" className="o2o-bulk-stepper-divider">›</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

Stepper.defaultProps = {
  isLocked: false,
};

Stepper.propTypes = {
  currentStep: PropTypes.oneOf([1, 2]).isRequired,
  isLocked: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
};

export default Stepper;
